// imports
import React from 'react';
import { Link } from '@react-router';
import { pxToRem } from '@withjoy/joykit/theme';
import { Hamburger } from '@withjoy/joykit/icons';
import { Flex, JoyKitThemeProvider, useTheme } from '@withjoy/joykit';

// local imports
import { useIsFeatureEnabled } from '@shared/core/featureFlags';
import { ReactComponent as JoyLogo } from '@assets/joy-logo.svg';
import { CurrencySelector } from '@shared/components/CurrencySelector';
import { useColorPaletteProvider } from '../../layouts/ColorPaletteProvider/ColorPaletteProvider';
import { TopBarContainer, HamburgerButton, LogoContainer, CurrencySelectorContainer } from './EventTopBar.styles';

interface EventTopBarProps
  extends Readonly<{
    eventHandle: string;
    onMenuOpen: () => void;
  }> {}

export const EventTopBar: React.FC<EventTopBarProps> = ({ eventHandle, onMenuOpen }) => {
  const theme = useTheme();
  const { pageColor, pageFontColor } = useColorPaletteProvider();
  const [isCurrencySelectorEnabled] = useIsFeatureEnabled('travelGuestCurrencySwitch');

  return (
    <TopBarContainer>
      <Flex
        gap={pxToRem(32)}
        alignItems="center"
      >
        <HamburgerButton
          variant="ghost"
          onClick={onMenuOpen}
        >
          <Flex
            width="100%"
            height="100%"
            overflow="hidden"
            alignItems="center"
            color={pageFontColor}
            justifyContent="center"
            backgroundColor={pageColor}
            borderRadius={pxToRem(12)}
          >
            <Hamburger size={32} />
          </Flex>
        </HamburgerButton>

        <LogoContainer
          as={Link}
          to={`/${eventHandle}`}
        >
          <JoyLogo
            width={pxToRem(48)}
            height={pxToRem(30)}
            style={{ color: pageFontColor || theme.colors.mono14 }}
          />
        </LogoContainer>
      </Flex>

      <JoyKitThemeProvider>
        <CurrencySelectorContainer>
          <CurrencySelector isEnabled={isCurrencySelectorEnabled} />
        </CurrencySelectorContainer>
      </JoyKitThemeProvider>
    </TopBarContainer>
  );
};
